// front-end/src/components/block-system/block-manager/block-state.js

// Утилита для проверки, является ли блок новостным
function isNewsBlockByName(blockName) {
  if (!blockName) return false;
  return blockName.startsWith('news-') || blockName.startsWith('news-block-');
}

const state = {
  pendingBlocks: [],
  pendingDeleteBlocks: [],
  blockCounters: {}, // Теперь будет хранить счетчики по типам блоков с учетом префиксов
  inited: false,
  loadedSections: {},
  blockOrderData: {}
};

export function getState() {
  return { ...state };
}

// ИСПРАВЛЕННАЯ ФУНКЦИЯ: Инициализируем счетчик на основе существующих блоков с учетом префиксов
export function getNextBlockNumber(blockPrefix) {
  // Если счетчик еще не инициализирован для этого префикса
  if (!state.blockCounters[blockPrefix]) {
    console.log(`[BlockState] Инициализация счетчика для префикса: ${blockPrefix}`);

    // Находим все существующие блоки этого префикса
    const existingBlocks = document.querySelectorAll(`[data-block-name^="${blockPrefix}-"]`);
    let maxNumber = 0;

    existingBlocks.forEach(block => {
      const blockName = block.getAttribute('data-block-name');
      if (blockName) {
        // Извлекаем номер из имени блока (например, "work-process-step-3" -> 3)
        const match = blockName.match(new RegExp(`^${escapeRegExp(blockPrefix)}-(\\d+)$`));
        if (match && match[1]) {
          const number = parseInt(match[1], 10);
          if (!isNaN(number) && number > maxNumber) {
            maxNumber = number;
          }
        }
      }
    });

    console.log(`[BlockState] Найден максимальный номер для ${blockPrefix}: ${maxNumber}`);
    state.blockCounters[blockPrefix] = maxNumber;
  }

  // Увеличиваем счетчик и возвращаем
  const nextNumber = ++state.blockCounters[blockPrefix];
  console.log(`[BlockState] Следующий номер для ${blockPrefix}: ${nextNumber}`);
  return nextNumber;
}

// НОВАЯ ФУНКЦИЯ: Экранирование строки для RegExp
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// ОБНОВЛЕННАЯ ФУНКЦИЯ: Инициализация счетчиков при загрузке страницы с учетом префиксов
export function initializeBlockCounters() {
  console.log('[BlockState] Инициализация счетчиков блоков...');

  // Находим все блоки на странице
  const allBlocks = document.querySelectorAll('[data-block-name]');
  const blockTypeCounts = {};

  allBlocks.forEach(block => {
    const blockName = block.getAttribute('data-block-name');
    if (!blockName) return;

    // Извлекаем префикс и номер из имени блока
    const match = blockName.match(/^(.+?)-(\d+)$/);
    if (match && match[1] && match[2]) {
      const blockPrefix = match[1];
      const blockNumber = parseInt(match[2], 10);

      if (!isNaN(blockNumber)) {
        if (!blockTypeCounts[blockPrefix] || blockTypeCounts[blockPrefix] < blockNumber) {
          blockTypeCounts[blockPrefix] = blockNumber;
        }
      }
    }
  });

  // Устанавливаем счетчики
  Object.keys(blockTypeCounts).forEach(blockPrefix => {
    state.blockCounters[blockPrefix] = blockTypeCounts[blockPrefix];
    console.log(`[BlockState] Счетчик ${blockPrefix}: ${blockTypeCounts[blockPrefix]}`);
  });

  console.log('[BlockState] Счетчики инициализированы:', state.blockCounters);
}

function dispatchPendingChange() {
  const hasPending = hasChanges();
  const count = state.pendingBlocks.length + state.pendingDeleteBlocks.length;
  document.dispatchEvent(new CustomEvent('pendingChanges:updated', {
    detail: { hasPending, count }
  }));
}

export function addPendingBlock(blockData) {
  state.pendingBlocks.push(blockData);
  dispatchPendingChange();
}

export function removePendingBlock(blockName) {
  state.pendingBlocks = state.pendingBlocks.filter(block =>
    block.data_block_name !== blockName
  );
}

export function addPendingDeleteBlock(element, id, originalDisplay) {
  if (!element) {
    console.error('addPendingDeleteBlock called without element reference');
    return;
  }

  const blockName = element.getAttribute('data-block-name');

  const blockInfo = {
    element,
    id,
    originalDisplay: originalDisplay || 'block',
    blockName: blockName,
    newsId: element.getAttribute('data-news-id'),
    isNewsBlock: isNewsBlockByName(blockName),
    hasNewsEntity: !!element.getAttribute('data-news-id'),
    newsStatus: element.getAttribute('data-news-status')
  };

  state.pendingDeleteBlocks.push(blockInfo);
  dispatchPendingChange();

  console.log('Added pending delete block:', {
    id,
    blockName: blockInfo.blockName,
    isNewsBlock: blockInfo.isNewsBlock,
    hasNewsEntity: blockInfo.hasNewsEntity,
    newsId: blockInfo.newsId,
    newsStatus: blockInfo.newsStatus
  });
}

export function clearPendingChanges() {
  state.pendingBlocks = [];
  state.pendingDeleteBlocks = [];
  state.blockOrderData = {};
  dispatchPendingChange();
}

export function getPendingBlocks() {
  return [...state.pendingBlocks];
}

export function getPendingDeleteBlocks() {
  return [...state.pendingDeleteBlocks];
}

export function hasChanges() {
  return state.pendingBlocks.length > 0 ||
         state.pendingDeleteBlocks.length > 0 ||
         Object.keys(state.blockOrderData).length > 0;
}

export function markSectionLoaded(sectionName) {
  state.loadedSections[sectionName] = true;
}

export function isSectionLoaded(sectionName) {
  return !!state.loadedSections[sectionName];
}

// ОБНОВЛЕННАЯ ФУНКЦИЯ: Обновление счетчика с учетом префикса
export function updateBlockCounter(blockTypeOrPrefix, blockNumber) {
  if (!state.blockCounters[blockTypeOrPrefix] || state.blockCounters[blockTypeOrPrefix] < blockNumber) {
    state.blockCounters[blockTypeOrPrefix] = blockNumber;
  }
}

export function setInitialized(value = true) {
  state.inited = value;
}

export function isInitialized() {
  return state.inited;
}

export function updateBlockOrderData(sectionName, orderData) {
  state.blockOrderData[sectionName] = orderData;
  window.blockOrderData = state.blockOrderData;
  dispatchPendingChange();
}

export function getBlockOrderData() {
  return { ...state.blockOrderData };
}

export function hasBlockOrderChanges() {
  return Object.keys(state.blockOrderData).length > 0;
}